export enum DealPaymentTypeEnum {
    CreditCard = 1,
    BankDebit = 2
}


// WEBPACK FOOTER //
// ./src/app/_enums/deal-payment-type.enum.ts